<div
  class="badge"
  [ngClass]="data.status"
>
  <span>
    {{ data.text }}
  </span>
</div>